import React, { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import { useTranslation } from 'react-i18next';
import {
  fetchOrderListDetails,
  getOrderListDetails,
  getOrdersListDetailsLoaders,
  resetDetails,
  OrderListProduct
} from 'features/OrdersList/ordersListForm';
import { getCustomerDetails } from 'features/CustomerDetails/customerForm';
import { BottomActionBar } from 'components/UI/BottomActionBar';
import { ButtonLoader } from 'components/Loaders/ButtonLoader';
import { Row } from 'components/UI/Row';
import { Column } from 'components/UI/Column';
import { ProductTable } from './tables/ProductTable';
import { SerialTable } from './tables/SerialTable';

interface LinkToOrderListProps {}

interface LinkOrderListForm {
  complianceDeclaration: string;
  isCompliant: boolean;
  ourOrder: string;
  testType: string;
  yourOrder: string;
}

const TestReport = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { orderListId } = useParams<{ orderListId?: string }>();
  const orderList = useSelector(getOrderListDetails);
  const customer = useSelector(getCustomerDetails);
  const { isLoading, isSaving } = useSelector(getOrdersListDetailsLoaders);

  const { handleSubmit, control } = useForm<LinkOrderListForm>({
    mode: 'onBlur'
  });

  useEffect(() => {
    if (orderListId) {
      dispatch(fetchOrderListDetails(orderListId));
    }
    return () => {
      dispatch(resetDetails());
    };
  }, [orderListId]);

  const onSubmit = async (formData: LinkOrderListForm) => {
    console.log(formData);
  };

  return (
    <>
      <form
        onSubmit={handleSubmit(onSubmit)}
        noValidate
        style={{ display: 'flex', flexDirection: 'column', paddingBottom: '60px' }}
      >
        <Row flex={0.5}>
          <Column flex={0.5} border="solid 1px lightgrey">
            <span style={{ padding: '10px 20px' }}>{customer?.company_name}</span>
            <span style={{ padding: '10px 20px' }}>{customer?.address}</span>
            <span style={{ padding: '10px 20px' }}>
              {customer?.zip_code} {customer?.city}
            </span>
            <span style={{ padding: '10px 20px  ' }}>{customer?.tax_code}</span>
          </Column>
        </Row>

        <span style={{ padding: '20px 0 10px' }}>REPORT DI COLLAUDO N XX</span>

        <Controller
          as={
            <TextField
              fullWidth
              autoComplete="new-password"
              /* helperText={t(get(errors, 'name.message'))}
                error={!isEmpty(get(errors, `name`))} */
              label={t('testReport.your order')}
              style={{ margin: '16px 0' }}
              variant="outlined"
            />
          }
          control={control}
          defaultValue=""
          name="yourOrder"
        />
        <Controller
          as={
            <TextField
              fullWidth
              autoComplete="new-password"
              /* helperText={t(get(errors, 'name.message'))}
                error={!isEmpty(get(errors, `name`))} */
              label={t('testReport.our order')}
              style={{ margin: '16px 0' }}
              variant="outlined"
            />
          }
          control={control}
          defaultValue=""
          name="ourOrder"
        />
        <Controller
          as={
            <TextField
              fullWidth
              autoComplete="new-password"
              /* helperText={t(get(errors, 'name.message'))}
                error={!isEmpty(get(errors, `name`))} */
              label={t('testReport.test type')}
              style={{ margin: '16px 0' }}
              variant="outlined"
            />
          }
          control={control}
          defaultValue=""
          name="testType"
        />

        <Row alignItems="center" style={{ marginBottom: '16px' }}>
          <span>{t('testReport.is compliant')}</span>
          <Controller
            render={({ onChange, value, ref }) => (
              <Checkbox
                onChange={e => onChange(e.target.checked)}
                checked={value}
                inputRef={ref}
                color="primary"
                name="isCompliant"
                inputProps={{
                  'aria-label': 'isCompliant component'
                }}
              />
            )}
            control={control}
            defaultValue={false}
            name="isCompliant"
          />
        </Row>

        <Controller
          as={
            <TextField
              /* helperText={t(get(errors, 'name.message'))}
              error={!isEmpty(errors.name)} */
              label={t('testReport.compliance declaration')}
              style={{ marginBottom: '16px' }}
              variant="outlined"
              fullWidth
              multiline
              rows={5}
            />
          }
          control={control}
          defaultValue=""
          name="complianceDeclaration"
        />

        <span>product and serial numbers</span>
        {orderList?.products.map((p: OrderListProduct) => (
          <div style={{ padding: '20px 0' }}>
            <ProductTable product={p} />
            <SerialTable serialNumbers={p.serial_number} />
          </div>
        ))}

        <BottomActionBar>
          <Row padding="20px" justifyContent="flex-end">
            <Button type="submit" color="primary" disabled={isLoading || isSaving} variant="contained">
              {t('label.save')}
              <ButtonLoader show={isSaving} />
            </Button>
          </Row>
        </BottomActionBar>
      </form>
    </>
  );
};

export { TestReport };
